export const validCampaignConditions = (condition: any) => {
  return condition?.fieldName && condition?.value;
};

export const filterCampaignConditions = (conditions: any[]) => {
  return (conditions || [])
    .map((config) => ({
      ...config,
      conditions: (config.conditions || []).filter((cond: any) =>
        validCampaignConditions(cond),
      ),
    }))
    .filter((config) => config?.campaignId && config?.conditions?.length > 0);
};
